export const VALIDATION_REG_EXP_NAME = /^[a-z ,.'-]{2,20}$/i
export const VALIDATION_REG_EXP_MOBILE = /^[+]{0,1}[0-9()]{8,16}$/
export const VALIDATION_REG_EXP_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
